export default __webpack_public_path__ + "static/media/bank_bay.09121990.svg";